<template>
  <div class="relative h-96 ml-5 mr-5 mb-5">
    <div v-if="isLoading" class="h-full">
      <div class="flex items-end space-x-2 h-full">
        <div class="bg-gray-100 h-32 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-3/4 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-20 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-52 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-20 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-32 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-36 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-20 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-32 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-56 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-60 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-48 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-20 w-8 animate-pulse rounded"></div>
        <div class="bg-gray-100 h-40 w-8 animate-pulse rounded"></div>
      </div>
    </div>
    <canvas ref="statisticsStudentTaps" class="cursor-pointer"></canvas>
  </div>
</template>
<script>
import Vue from "vue";
import Chart from 'chart.js';
import moment from 'moment';
import { mapGetters } from "vuex";
import getLiveRoundtableEngagement from "services/courses/getLiveRoundtableEngagement";
import getMyLiveRoundtableEngagement from "services/courses/getMyLiveRoundtableEngagement";
import { EventBus } from "../../../../../utils/event-bus";

export default Vue.extend({
  data(){
    return {
      statisticsChart: null,
      isLoading: false,
    };
  },
  watch: {
   '$route': function () {
      /* Restart Chart When Route Changes */
      this.statisticsChart.destroy();
      this.getChartData();
    },
  },
  computed: {
    ...mapGetters(["getProfile", "hasTeacherPermissionsInCourse"]),
  },
  methods: {
    setChart: function (studentLiveDiscussions) {
      studentLiveDiscussions = studentLiveDiscussions.filter((live => live.average_absolute_class_current_speakers !== 0 && live.time_absolute_as_current_speaker !== 0));
      this.statisticsChart = new Chart(this.$refs.statisticsStudentTaps,
        {
          type: "bar",
          data: {
            labels: studentLiveDiscussions.map((live) => live.live_discussion),
            datasets: [
              {
                label: "Class Average as Speaker",
                data: studentLiveDiscussions.map((rt) => rt.average_absolute_class_current_speakers),
                borderColor: "#FF9419",
                fill: false,
                borderWidth: 3,
                type: "line",
              },
              {
                label: "Total Time as Speaker",
                data: studentLiveDiscussions.map((live) => live.time_absolute_as_current_speaker),
                backgroundColor: "#283248",
                maxBarThickness: 64,
              },
            ],
          },
          options: {
            scales: {
              xAxes: [{ ticks: { display: false } }],
              yAxes: [{ ticks: { beginAtZero: true, userCallback: (label) => (Math.floor(label) === label ? label : "")}}],
            },
            onClick: (evt, activeElements) => {
              if (activeElements.length > 0) {
                const tooltipEl = document.getElementById('chartjs-tooltip');
                const children = tooltipEl.children[0].children;
                if (tooltipEl)  {
                  tooltipEl.remove();
                }
                if (this.getProfile.is_paid === false) {
                  return;
                }
                EventBus.$emit('handleChangeReportsTab', 'course.student-reports.discussion', children[0].id);
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: { right: 5 }},
            legend: { display: true, position: 'bottom', align: 'start', labels: { boxWidth: 12, boxHeight: 10 }},
            tooltips: {
              enabled: false,
              custom: function (tooltipModel) {
                let tooltip = document.getElementById('chartjs-tooltip');
                if (!tooltip) {
                  tooltip = document.createElement('div');
                  tooltip.id = 'chartjs-tooltip';
                  tooltip.innerHTML ='<div class="bg-white py-2 rounded shadow-lg"></div>';
                  document.body.appendChild(tooltip);
                }
                if (tooltipModel.opacity === 0) {
                  tooltip.style.opacity = '0';
                  if (tooltip) {
                    tooltip.parentNode.removeChild(tooltip);
                  }
                  return;
                }
                let title = tooltipModel.title;
                const roundTableToShow = studentLiveDiscussions.find((rt) => {
                  return rt.live_discussion === title[0];
                }); 
                if (tooltipModel.body) { 
                  const innerHtml = `
                    <div id="${roundTableToShow.live_discussion_id}">
                      <div class="flex items-center space-x-2 px-4 py-1">
                        <div class="h-5 w-5 bg-green-dark rounded-full flex items-center justify-center">
                          <img src="/static/roundtable_icons/verbal_icon.svg" class="w-2.5 h-2.5"/>
                        </div>
                        <h6 class="font-poppins font-semibold text-blueGray-800">${roundTableToShow.live_discussion.charAt(0).toUpperCase() + roundTableToShow.live_discussion.slice(1)}</h6>
                      </div>
                      <div class="border-b border-solid border-gray-200 mb-0.5 mt-1.5"></div>
                      <div class="px-4 py-2 font-poppins text-blueGray-800">
                        <div class="flex items-center mb-1">
                          <div class="w-3 h-3 bg-blueGray-800 mr-2"></div>
                          <p>Time as Speaker: <span class="font-semibold text-gray-700 ml-1">${roundTableToShow.time_spent_as_current_speaker}</span></p>
                        </div>
                        <div class="flex items-center">
                          <div class="w-3 h-3 bg-orange mr-2"></div>
                          <p>Class Average as Speaker: <span class="font-semibold ml-1 text-gray-700">${roundTableToShow.average_class_current_speakers}</span></p>
                        </div>
                      </div>
                    </div>
                  `;
                  tooltip.querySelector('div').innerHTML = innerHtml;
                }
                let position = this._chart.canvas.getBoundingClientRect();
                tooltip.style.opacity = 1;
                tooltip.style.position = 'absolute';
                tooltip.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                tooltip.style.top = (position.top - 100) + window.pageYOffset + tooltipModel.caretY + 'px';
                tooltip.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
                tooltip.style.pointerEvents = 'none';
                tooltip.style.fontSize = '12px';
              }  
            },
          },
          plugins: [{
            afterDraw: function(chart) {
              // Customize Year for Empty Data Or Change to HTML
              if (chart.data.datasets[0].data.length === 0) {
                let ctx = chart.chart.ctx;
                let width = chart.chart.width;
                let height = chart.chart.height;
                chart.clear();
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText('No data to display', width / 2, height / 2);
                ctx.restore();
              }
            }
          }],
        }
      );
    },
    getChartData: async function(){
      this.isLoading = true;
      const { courseID, studentID } = this.$route.params;
      const { startDate, endDate } = this.$route.query;
      const dateStart =  startDate !== undefined ? moment.unix(startDate).format('YYYY/MM/DD') + ' ' + '00:00:00' : '';
        const dateEnd = endDate !== undefined ? moment.unix(endDate).format('YYYY/MM/DD') + ' ' + '23:59:59' : '';
        if(this.getProfile.id === studentID) {
          const result = await getMyLiveRoundtableEngagement(courseID, dateStart, dateEnd);
          this.isLoading = false;
          return this.setChart(result);
        }
        const result = await getLiveRoundtableEngagement(courseID, studentID, dateStart, dateEnd);
        this.isLoading = false;
        return this.setChart(result);
    },
  },
  mounted: async function() {
    if (this.getProfile.is_paid === false) {
      this.isLoading = true;

      const result = [
        {
          live_discussion:'Sample Verbal RoundTable',
          live_discussion_id: '4',
          live_discussion_created_date: '2024-05-20T08:50:27.881Z',
          time_spent_as_current_speaker: '00h 04m 16s',
          time_absolute_as_current_speaker: 5.140333333333333,
          average_absolute_class_current_speakers: 2.13333333333333333,
          new_idea: 1,
          challenge: 0,
          question: 0,
          build_on: 0,
          hand_raise: 0,
          average_class_current_speakers: '00h 08m 08s',
        },
        {
          live_discussion: "Diplomatic Negotiations and Security Concerns: U.S.-Russia Talks on Ukraine Conflict",
          live_discussion_id: '5',
          live_discussion_created_date: '2024-08-09T11:30:07.658Z',
          time_spent_as_current_speaker: '00h 03m 13s',
          time_absolute_as_current_speaker: 4.140333333333333,
          average_absolute_class_current_speakers: 4.21666666666666667,
          new_idea: 0,
          challenge: 1,
          question: 0,
          build_on: 1,
          hand_raise: 0,
          average_class_current_speakers: '00h 06m 03s',
        },
        {
          live_discussion: 'World War I: Unprecedented Carnage and the Fall of Empires',
          live_discussion_id: '6',
          live_discussion_created_date: '2024-10-03T08:06:19.802Z',
          time_spent_as_current_speaker: '00h 07m 08s',
          time_absolute_as_current_speaker: 7.140333333333333,
          average_absolute_class_current_speakers: 7.133333333333334,
          new_idea: 0,
          challenge: 6,
          question: 1,
          build_on: 5,
          hand_raise: 3,
          average_class_current_speakers: '00h 07m 08s',
        },
      ];

      this.isLoading = false;
      this.setChart(result);
      return;
    }
    this.getChartData();
  },
});
</script>




// WEBPACK FOOTER //
// SpeakingChart.vue?7f32f6c6